import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import ContactPages from './pages/ContactPages';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

const Navigation = () => {
  const location = useLocation();

  if (location.pathname === "/") {
    return null;
  }

  return <Navbar />;
};

function App() {
  return (
    <HelmetProvider>
    <Router>
      <Navigation /> 
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/contact" element={<ContactPages />} />
      </Routes>
      
      <Footer />
      <ScrollToTop />
    </Router>
    </HelmetProvider>
  );
}

export default App;